import { isLogin } from 'utils/token'
import Main from './Main'

const VerificationAlert = ({ onVerify }) => {
  if (!isLogin()) return null
  return <Main onVerify={onVerify} />
}

export default VerificationAlert
